export default "images/junior suite.jpg";